import { PlusOutlined } from "@ant-design/icons";
import {
  Drawer,
  Form,
  Select,
  Typography,
  message
} from "antd";
import * as ROOMS_SERVICES from "api/services/rooms/rooms.services";
import * as TEACHER_SERVICES from "api/services/teacher/teacher.services";
import React, { FC, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styles from "./style.module.css";

import { StatusCode } from "common/enums";
import AppButton from "components/libs/button";
import H1 from "components/libs/title";
import * as appRoutes from "config/routes.config";
import { useNavigate } from "react-router-dom";
import AppScreen from "../ScreenWithSidebar";

//!IMAGES
import ArrowBack from "../../../assets/images/app/arrow_back.svg";
import ChallengeIcon from "../../../assets/images/app/challenge-icon.png";
import ClockIcon from "../../../assets/images/app/clock_icon.svg";
import ContributionIcon from "../../../assets/images/app/contributions_icon.svg";
import BookIcon from "../../../assets/images/app/Cours.svg";
import UsersIcon from "../../../assets/images/app/iam_student.svg";
import AlbertImage from "../../../assets/images/app/levieuxalbert.svg";
import PublicationIcon from "../../../assets/images/app/publications_icon.svg";
import TrophyIcon from "../../../assets/images/app/trophy-icon.jpg";
import Teacher from "../../../assets/images/icons/teacher.svg";
import GraduationIcon from "../../../assets/images/icons/teacher_classes.svg";

//
import AppResult from "components/appResults";
import Breadcrumbs from "components/breadcrumbs";
import { useGetRoomsQuery } from "store/services/teacher/classes.services";
import { useGetContributionsQuery } from "store/services/teacher/contributions.services";
import { useGetContentCountQuery } from "store/services/teacher/count.services";
import CardContribution from "../components/cardContribution";
import DrawerPublications from "../components/drawerPublications";
import ContentStats from "./components/contributions";
import OverviewCard from "./components/OverviewCard";

const { Paragraph, Text } = Typography;
const { Option } = Select;
const MESSAGE_PREFIX_PARTAGE_RESEAUX_SOCIAUX =
  "Bonjour ! Rejoins ma classe sur Monamilabert.com en utilisant ce code :";

const TeacherDashboard: FC = () => {
  //!HOOKS
  const auth = useSelector((state) => state.auth);
  const { t } = useTranslation();
  const { data: rooms, isLoading, isError, refetch } = useGetRoomsQuery(auth?.user?._id);
  const courses = useSelector((state) => state.courses);
  const quizzes = useSelector((state) => state.quizz);
  const exercices = useSelector((state) => state.exercises);
  const [addCourseForm] = Form.useForm();
  const navigate = useNavigate();
  const hide = () => setVisibleSocialMedia(false);
  const { user } = useSelector((state) => state.auth);
  const { userHavingCalendar, userTeachingOrganismClass } = useSelector((state) => state.app);
  //!STATE
  const [teacherData, setTeacherData] = useState<any>();
  const [isLoadingData, setIsLoadingData] = useState<boolean>(false);
  const [showAddClasse, setShowAddClasse] = useState<boolean>(false);
  const [isModalSuccessAddCours, setIsModalSuccessAddCours] =
    useState<boolean>(false);
  const [tempRoom, setTempRoom] = useState<any>(null);
  const [code, setCode] = useState(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  const [isDrawerPublicationsVisible, setIsDrawerPublicationsVisible] = useState(false);
  const [openDrawerPublications, setOpenDrawerPublications] = useState(false);
  const { data, isLoading: isLoadingContributions } = useGetContentCountQuery(user?._id);
  const { data: publicationsData, isLoading: isLoadingPublications, isError: isErrorPublications, refetch: refetchPublications } = useGetContributionsQuery({
    profId: user?._id,
    self: true,
  });

  //!ADD COURSE
  const [addCourseLoading, setAddCourseLoading] = useState(false);

  //FUNCTIONS
  const goToTeacherRooms = () => navigate(appRoutes.TEACHER_ROOMS);
  const [visibleSocialMedia, setVisibleSocialMedia] = useState(false);
  const handleVisibleChange = () => {
    setVisibleSocialMedia(!visibleSocialMedia);
  };

  const fetchTeacherData = async () => {
    try {
      setIsLoadingData(true);
      const response = await TEACHER_SERVICES.fetchTeacherData(user?._id);
      if (response?.statusCode === StatusCode.OK) {
        setTeacherData(response?.data);
      }
    } catch (error: any) {
      message.error(error?.message || "error");
    } finally {
      setIsLoadingData(false);
    }
  };

  const addCourse = useCallback(
    async (course: any) => {
      try {
        setAddCourseLoading(true);
        course.teacherId = auth.user?._id;
        const response = await ROOMS_SERVICES.createRoom(course);
        if (response?.statusCode === StatusCode.CREATED) {
          setTempRoom(response?.data);
          setShowAddClasse(false);
          refetch();
          message.success("créé avec succès !");
          addCourseForm.resetFields();
          setTimeout(() => {
            setIsModalSuccessAddCours(true);
            setCode(response.data);
          }, 1500);
        }
      } catch (error: any) {
        message.error(error?.message || "error");
      } finally {
        setAddCourseLoading(false);
      }
    },
    [addCourseForm]
  );

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    if (user) {
      fetchTeacherData();
    }
  }, [user]);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      console.log(hash);
      const element = document.getElementById(hash.substring(1)); // Remove the '#' from the hash
      if (element) {
        console.log(element);
        element.scrollIntoView({ behavior: 'smooth' });

        // Add a small delay to allow scrollIntoView to complete before applying scroll offset
        if (hash === "#content-section") {
          setTimeout(() => {
            window.scrollBy({
              top: 50, // Scroll 100px more upwards
              behavior: 'smooth',
            });
          }, 300);
        }
        else {
          setTimeout(() => {
            window.scrollBy({
              top: 750, // Scroll 100px more upwards
              behavior: 'smooth',
            });
          }, 300);
        }
      }
    }
  }, []);

  const overviewCards = [
    {
      value: teacherData?.hours_completed,
      label: "Nombre d’heures<br/>réalisées",
      icon: ClockIcon,
      size: 25,
    },
    {
      value: teacherData?.private_courses_count,
      label: "Nombre de cours<br/>particuliers",
      icon: BookIcon,
      size: 35,
    },
    {
      value: teacherData?.group_courses_count,
      label: "Nombre de cours<br/>collectifs",
      icon: GraduationIcon,
      size: 35,
    },
    {
      value: teacherData?.students_count,
      label: "Nombre<br/>d’élèves",
      icon: UsersIcon,
      size: 40,
    },
    {
      value: teacherData?.contributions_count,
      label: "Nombre de<br/>contributions",
      icon: ContributionIcon,
      size: 25,
    },
    {
      value: teacherData?.publications_count,
      label: "Nombre de<br/>publications",
      icon: PublicationIcon,
      size: 30,
    },
    {
      value: teacherData?.points,
      label: "Nombre de<br/>points",
      icon: TrophyIcon,
      size: 45,
    },
    {
      value: teacherData?.challenges_launched_count,
      label: "Nombre de<br/>challenges lancés",
      icon: ChallengeIcon,
      size: 45,
    },
  ];

  const handleShowPublications = () => {
    setIsDrawerPublicationsVisible(true);
  }

  return (
    <React.Fragment>
      <div style={{ marginTop: isMobile ? (!userHavingCalendar || userTeachingOrganismClass) ? "130px" : "70px" : "0px", marginBottom: "10rem" }}>

        {!isMobile && <Breadcrumbs isDashboard={true} />}

        {user?.isActive && user?.step === "completed" ? <AppScreen className={styles.dashboard}>

          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "40px", gap: "10px" }}>
            <img src={user?.profile || Teacher} height={50} style={{ borderRadius: "50%" }} />
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              <div style={{ color: "#000", fontSize: "1.3em", fontWeight: 600 }}>Bienvenue {user?.firstname + " " + user?.lastname}</div>
              <span style={{ color: "#8fb2b2", fontSize: "1.1em", fontWeight: 500 }}>
                {user?.points > 0 &&
                  user?.points <= 1000 &&
                  "Tu es mon ami"}

                {user?.points > 1000 &&
                  user?.points <= 5000 &&
                  "Tu es mon grand ami"}

                {user?.points > 5000 &&
                  user?.points <= 10000 &&
                  "Tu es mon vieile ami"}

                {user?.points > 10000 && "Tu es mon meilleur ami"}
              </span>
            </div>
          </div>

          <div className={styles.overviewSection}>
            <h3 className={styles.overviewTitle}>Vue d’ensemble</h3>

            <div className={styles.overviewGrid}>
              {overviewCards.map((card, index) => (
                <OverviewCard key={index} {...card} onShowPublications={handleShowPublications} />
              ))}
            </div>
          </div>

          {!isLoadingContributions && <ContentStats data={data?.data} />}

          {/* Drawer Publications */}
          <Drawer
            className="drawer"
            placement="right"
            onClose={() => setIsDrawerPublicationsVisible(false)}
            visible={isDrawerPublicationsVisible}
            width={isMobile ? "100%" : "65%"}
            title={
              <div style={{ fontSize: isMobile ? "0.8em" : "20px", fontFamily: "Poppins", fontWeight: "600", color: "#393E3E", backgroundColor: "transparent", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                Mes publications
                <AppButton
                  icon={<PlusOutlined />}
                  onClick={() => setOpenDrawerPublications(true)}
                >
                  Ajouter une publication
                </AppButton>
              </div>
            }
            headerStyle={{ border: "none", paddingTop: "50px", paddingLeft: isMobile ? "20px" : "40px", backgroundColor: "transparent" }}
            closeIcon={
              <img
                src={ArrowBack}
                height={isMobile ? 10 : 18}
                style={{}}
              ></img>
            }
            drawerStyle={{ backgroundColor: "#FFF", borderTopLeftRadius: isMobile ? "0px" : "50px", borderBottomLeftRadius: isMobile ? "0px" : "50px", boxShadow: "-3px 3px 34px #39393929" }}
            bodyStyle={{ zIndex: "1" }}
          >
            <div style={{ marginLeft: "5%", marginRight: "5%", }}>
              {!isLoadingPublications && publicationsData?.data?.results.length > 0 ? (
                publicationsData?.data?.results?.map((contribution: any, i: number) => (
                  <CardContribution key={i} contribution={contribution} />
                ))
              ) : (
                <AppResult status="info" title="Aucune publication" />
              )}
            </div>
          </Drawer>

          {/* Add Publications */}
          <DrawerPublications
            open={openDrawerPublications}
            setOpen={setOpenDrawerPublications}
            onPublicationAdded={refetchPublications}
          />
        </AppScreen> : <AppScreen className={styles.dashboard}>
          <H1 className={styles.title}>Bienvenue {auth?.user?.firstname}</H1>
          <div className={styles.dashboardUserBox}>
            <img src={AlbertImage} width={240} height={240} style={{ marginTop: "20px", marginBottom: "10px" }}></img>
            <p className={styles.dashboardUserMessage} style={{ fontFamily: "CartoonFont" }}>Oups, tu n’as pas encore accès à cette fonctionnalité!<br />Patience... ton compte est en cours de validation. </p>
            {user?.step !== "completed" && <AppButton onClick={() => navigate(appRoutes.COMPLETE_PROFILE)}>Completer mon profil</AppButton>}
          </div>
        </AppScreen>
        }
      </div>
    </React.Fragment>
  );
};

export default TeacherDashboard;
